const genderEnum = new Map();
genderEnum.set(0,"未知");
genderEnum.set(1,"男");
genderEnum.set(2,"女");

const disabledEnum = new Map();
disabledEnum.set(true,"禁用");
disabledEnum.set(false,"启用");

const openStateEnum = new Map();
openStateEnum.set(true,"开启");
openStateEnum.set(false,"关闭");

const yesOrNoEnum = new Map();
yesOrNoEnum.set(true,"是");
yesOrNoEnum.set(false,"关闭");

export default {
    "gender": genderEnum,
    "disabled": disabledEnum,
    "openState": openStateEnum,
    "yesOrNo": yesOrNoEnum,
}